import { render, staticRenderFns } from "./NsCampaign.vue?vue&type=template&id=4bfa86e0"
import script from "./NsCampaign.vue?vue&type=script&lang=js"
export * from "./NsCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports